import React, { useState, useEffect } from "react";
import "../styles/Login.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Signup() {
  const [centers, setCenters] = useState([]);
  const [assigners, setAssigners] = useState([]);
  const [signupData, setSignupData] = useState({
    username: "",
    email: "",
    password: "",
    mobile: "",
    confirm_password: "",
    role: "",
    center_id: "",
    assigner_id: "",
  });
  const navigate = useNavigate();

  // ================= FETCH CENTERS & ASSIGNERS =================
  useEffect(() => {
    fetchAssigners();
    fetchCenters();
  }, []);

  const fetchAssigners = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/assigners/`);
      setAssigners(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/centers/`);
      setCenters(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (field) => (e) =>
    setSignupData({ ...signupData, [field]: e.target.value });

  // ================= SIGNUP =================
  const handleSignup = async (e) => {
    e.preventDefault();

    if (signupData.password !== signupData.confirm_password) {
      alert("Passwords do not match");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/signup/`, signupData);
      navigate("/login"); // go to login page after successful signup
    } catch (err) {
      alert(err.response?.data?.message || "Signup Failed");
    }
  };

  const isCenterOrDoctor = ["center", "doctor"].includes(signupData.role);

  const usernameLabel =
    signupData.role === "assigner"
      ? "Reporting Company Name"
      : signupData.role === "doctor"
      ? "Doctor Username"
      : signupData.role === "center"
      ? "Center Username"
      : "Username";

  return (
    <div className="login-page">
      <div className="form form-wide" id="main-container">
        <header className="header">
          <h1>
            <i className="fas fa-user-plus"></i> Create Account - Radiology PACS
          </h1>
        </header>

        <div className="form-container active">
          <h2>Create New Account</h2>
          <form onSubmit={handleSignup}>
            <div className="form-group">
              <label>Role</label>
              <select
                required
                value={signupData.role}
                onChange={handleChange("role")}
              >
                <option value="">Select Role</option>
                <option value="admin">Admin</option>
                <option value="center">Center/Hospital</option>
                <option value="doctor">Doctor</option>
                <option value="assigner">Assigner</option>
              </select>
            </div>

            {/* ===== CENTER DROPDOWN ===== */}
            {isCenterOrDoctor && (
              <div className="form-group">
                <label>Select Center</label>
                <select
                  required={!signupData.assigner_id}
                  value={signupData.center_id}
                  onChange={handleChange("center_id")}
                >
                  <option value="">Select Center</option>
                  {centers.map((center) => (
                    <option key={center.id} value={center.id}>
                      {center.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* ===== REPORTING COMPANY DROPDOWN ===== */}
            {isCenterOrDoctor && (
              <div className="form-group">
                <label>Reporting Company (Optional)</label>
                <select
                  value={signupData.assigner_id}
                  onChange={handleChange("assigner_id")}
                >
                  <option value="">No Reporting Company</option>
                  {assigners.map((assigner) => (
                    <option key={assigner.id} value={assigner.id}>
                      {assigner.username}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>{usernameLabel}</label>
              <input
                type="text"
                placeholder={`Enter ${usernameLabel}`}
                required
                value={signupData.username}
                onChange={handleChange("username")}
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="Enter your email"
                required
                value={signupData.email}
                onChange={handleChange("email")}
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Create a strong password"
                required
                value={signupData.password}
                onChange={handleChange("password")}
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm your password"
                required
                value={signupData.confirm_password}
                onChange={handleChange("confirm_password")}
              />
            </div>

            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="text"
                placeholder="Enter your mobile number"
                required
                value={signupData.mobile}
                onChange={handleChange("mobile")}
              />
            </div>

            <button type="submit" className="btn btn-primary">
              <i className="fas fa-user-plus"></i> Sign Up
            </button>
          </form>

          <div className="form-footer">
            <p>
              Already have an account? <Link to="/login">Login here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;